import { academiaMejiasApi } from "../academiaMejiasApi";

export const getGruposAdmin = async (token: string, cursoId?: number) => {
  try {
    let data;
    if (cursoId) {
      const response = await academiaMejiasApi.get(`/admin/grupo/${cursoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      data = response.data;
    } else {
      const response = await academiaMejiasApi.get("/admin/grupos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      data = response.data;
    }

    return { ok: true, grupos: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const postGrupo = async (token: string, grupo: any) => {
  const { estado, ...dataGrupo } = grupo;

  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await academiaMejiasApi.post("/admin/grupos", dataGrupo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { ok: true, grupo: data };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const putGrupo = async (token: string, grupo: any) => {
  /* dentro de provider */

  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await academiaMejiasApi.put(
      `/admin/grupos/${grupo.id}`,
      grupo,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { ok: true, grupo: data };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const deleteGrupo = async (token: string, grupoId: number) => {
  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await academiaMejiasApi.delete(
      `/admin/grupos/${grupoId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { ok: true, grupo: data };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};
